export const icons = {
    // plus: require('../../assets/img/plus.svg'),
    // minus: require('../../assets/img/minus.svg'),
    // delete: require('../../assets/img/delete.svg'),
    // image: require('../../assets/img/image.svg'),
    // application: require('../../assets/img/application.svg'),
    // pdfFile: require('../../assets/img/pdf-file.svg'),
    // success: require('../../assets/img/success.svg'),
    // danger: require('../../assets/img/danger.svg'),
    // ok: require('../../assets/img/ok.svg'),
    // warning: require('../../assets/img/success.svg'),
    // cross: require('../../assets/img/cross.svg'),
    // rotateLeft: require('../../assets/img/rotate-left.svg'),
    // rotateRight: require('../../assets/img/rotate-right.svg'),
    // zoomIn: require('../../assets/img/zoom-in.svg'),
    // back: require('../../assets/img/back.svg'),
    // info: require('../../assets/img/info.svg'),
    // arrowLeft: require('../../assets/img/arrow-left.svg'),
    // arrowRight: require('../../assets/img/arrow-right.svg'),
    // thumbUp: require('../../assets/img/thumb-up.svg'),
    // thumbDown: require('../../assets/img/thumb-down.svg'),
    // settings: require('../../assets/img/settings.svg'),
    // download: require('../../assets/img/download.svg'),
    // infoOutline: require('../../assets/img/info-outline.svg'),
    // clip: require('../../assets/img/clip.svg'),
    // briefcase: require('../../assets/img/briefcase.svg')
  };
  


// WEBPACK FOOTER //
// ./src/app/shared/data.model.ts